import React, { useState } from "react";
import Spinner from "components/General-UI/Spinner";
import { addToEffice } from "slices/peopleSlice";
import Avatar from "components/Home/ui/Avatar";
import TickIcon from "graphics/icons/TickIcon";
import { getPersonName } from "helpers/randomHelpers";

const AddPersonRow = ({
  user_id,
  avatar_key,
  given_name,
  family_name,
  permEffice,
}) => {
  const [loading, setLoading] = useState(false);
  const [confirmedAdd, setConfirmedAdd] = useState(false);

  function tryToAdd() {
    addToEffice(permEffice.id, user_id)
      .then(() => {
        setConfirmedAdd(true);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }

  return (
    <div className={`person-row ${loading || confirmedAdd ? "disabled" : ""}`}>
      <div className={`Txt-avatar d-inline-block`}>
        <Avatar
          avatar_key={avatar_key}
          given_name={given_name}
          family_name={family_name}
        />
      </div>
      <div className={`Txt-member-name-role`}>
        <div className="name-role-container">
          <div className="Txt-member-name">
            {getPersonName(given_name, family_name)}
          </div>
        </div>
      </div>
      <button className={`add-member-button`} onClick={tryToAdd}>
        {loading ? (
          <div className={`pe-none d-inline-block`}>
            <Spinner />
          </div>
        ) : confirmedAdd ? (
          <TickIcon />
        ) : (
          <>
            <span style={{ marginRight: "4px", fontSize: "16px" }}>+</span>Add
          </>
        )}
      </button>
    </div>
  );
};

export default AddPersonRow;
